export const FaceDetectionsSearch = {
  title: "Face Detection Search",
  subjectId: "Person(s)",
  subjectIdPlaceholder: "Select person(s)",
  subjectIdRequired: "Select at least one person.",
  subject: "Person",
  probability: "Probability",
  detection: "Detection",
  detections: "Face Detections",
  noDetections: "No detections found.",
  showMap: "Show map",
  hideMap: "Hide map",
  expandMap: "Expand map",
  contractMap: "Contract map",
  hideMarks: "Hide markers",
  showMarks: "Show markers",
  startAnimation: "Start animation",
  stopAnimation: "Stop animation",
  camera: "Camera",
  hideUnavailableSensors: "Hide unavailable sensors",
  fetchError: "Could not load face detections. Please try again.",
  searchByImage: "Search by image",
  imageSearchTitle: "Search by image",
  uploadImageHint: "Click or drag a face image here",
  recognizing: "Recognizing...",
  noPersonsFound: "No matches found in the database.",
  applySelection: "Apply",
  retry: "Retry",
  uploadError: "Could not process the image. Please try again.",
  detectingFaces: "Detecting faces...",
  noFacesDetected: "No faces detected. You can crop manually.",
  cropManually: "Crop manually",
  selectFaceHint: "Select the face you want to search for",
  searchFace: "Search",
  manualCropLabel: "Manual",
  backToSelection: "Back",
  maxFacesHint: "Max. 3 faces",
  confirmCrop: "Confirm crop",
  stepSelectFace: "Select face",
  stepResults: "Results",
  changeImage: "Change image",
  successfullyCopiedToClipboard: "Name successfully copied to clipboard",
};
